var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "#FFF2EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5703 16H25.8672V20.4766H26.5703V16Z",
    fill: "#B95516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4453 17.8984H23.9688V18.6016H28.4453V17.8984Z",
    fill: "#B95516"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.882 18.8078C15.1375 18.8078 12.9039 16.5742 12.9039 13.8297C12.9039 11.0852 15.1375 8.85156 17.882 8.85156C20.6266 8.85156 22.8602 11.0852 22.8602 13.8297C22.8602 16.5742 20.6266 18.8078 17.882 18.8078ZM17.882 9.55469C15.5242 9.55469 13.607 11.4719 13.607 13.8297C13.607 16.1875 15.5242 18.1047 17.882 18.1047C20.2398 18.1047 22.157 16.1875 22.157 13.8297C22.157 11.4719 20.2398 9.55469 17.882 9.55469ZM25.0328 29.1484H10.7359C9.88984 29.1484 9.20312 28.4617 9.20312 27.6156V23.1953C9.20312 21.1281 10.2414 19.225 11.9828 18.107L12.3625 18.6977C10.825 19.6867 9.90625 21.3672 9.90625 23.1953V27.6156C9.90625 28.0727 10.2789 28.4453 10.7359 28.4453H25.0328C25.4922 28.4453 25.8672 28.0703 25.8672 27.6109V23.1953H26.5703V27.6109C26.5703 28.4594 25.8813 29.1484 25.0328 29.1484Z",
    fill: "#B95516"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalClients);
export default __webpack_public_path__ + "static/media/total-clients.440a4d42175c247f8012d855772d902a.svg";
export { ForwardRef as ReactComponent };